export function TypeColumn({ columns }) {
  return columns["TYPE"];
}
